import React from "react";

function Contact() {
  return (
    <div className="contact">
      <h2>Visit Our Boutique</h2>
      <p>📍 Balaghat, Madhya Pradesh</p>
      <p>📞 +91 9826388181</p>
      <p>🕒 Open: 10 AM – 8 PM</p>
      <a
        href="https://wa.me/919826388181"
        target="_blank"
        rel="noreferrer"
        className="primary-btn whatsapp-btn"
      >
        Chat on WhatsApp
      </a>
    </div>
  );
}

export default Contact;
